<template>
  <v-app>
    <!-- Modern App Bar - Login sayfasında gizle -->
    <v-app-bar
      v-if="$route.name !== 'Login'"
      color="primary"
      dark
      elevation="4"
      height="64"
      class="app-bar"
    >
      <!-- Mobile hamburger menu -->
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="d-md-none"
      ></v-app-bar-nav-icon>

      <!-- Logo/Title -->
      <v-app-bar-title class="app-title">
        Logger Status
      </v-app-bar-title>

      <!-- Desktop Navigation Menu -->
      <div class="d-none d-md-flex align-center ml-8">
        <v-btn
          v-for="item in menuItems"
          :key="item.title"
          :to="item.to"
          text
          class="nav-btn mx-1"
          :class="{ 'nav-btn--active': $route.path === item.to }"
        >
          <v-icon left size="20">{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </div>

      <v-spacer></v-spacer>

      <!-- Action buttons -->
      <div class="d-flex align-center">
        <v-btn
          icon
          @click="refreshData"
          class="action-btn"
          :loading="refreshing"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <v-menu offset-y>
          <template v-slot:activator="{ props }">
            <v-btn icon class="action-btn ml-2" v-bind="props">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="toggleTheme">
              <v-list-item-icon>
                <v-icon>mdi-theme-light-dark</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Tema Değiştir</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout" v-if="isAuthenticated">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Çıkış Yap</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <!-- Mobile Navigation Drawer - Login sayfasında gizle -->
    <v-navigation-drawer
      v-if="$route.name !== 'Login'"
      v-model="drawer"
      app
      temporary
      class="mobile-drawer"
    >


      <v-list nav>
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          :to="item.to"
          link
          class="drawer-item"
          @click="drawer = false"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-4">
          <v-btn
            block
            color="primary"
            variant="outlined"
            @click="refreshData"
            :loading="refreshing"
          >
            <v-icon left>mdi-refresh</v-icon>
            Yenile
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main class="main-content" v-if="$route.name !== 'Login'">
      <router-view @refresh="refreshData" />
    </v-main>
    
    <!-- Login sayfası için tam ekran -->
    <div v-else class="login-container">
      <router-view />
    </div>
  </v-app>
</template>

<script>
import { getAuthFromCookie, clearAuthCookie } from '@/plugins/axios'

export default {
  name: 'App',
  data() {
    return {
      drawer: false,
      refreshing: false,
      menuItems: [
        {
          title: 'Dashboard',
          icon: 'mdi-view-dashboard',
          to: '/'
        },
        {
          title: 'Sunucular',
          icon: 'mdi-server',
          to: '/servers'
        },
        {
          title: 'Bildirimler',
          icon: 'mdi-bell',
          to: '/notifications'
        },
        {
          title: 'Bildirim Ayarlari',
          icon: 'mdi-cog-outline',
          to: '/notification-config'
        },
        {
          title: 'Otomatik Restart',
          icon: 'mdi-timer-cog',
          to: '/auto-restart'
        },
        {
          title: 'Bildirim Logları',
          icon: 'mdi-bell-alert',
          to: '/notification-logs'
        },
        {
          title: 'Restart Logları',
          icon: 'mdi-restart',
          to: '/restart-logs'
        }
      ]
    }
  },
  computed: {
    isAuthenticated() {
      return !!getAuthFromCookie()
    }
  },
  mounted() {
    this.loadThemePreference()
  },
  methods: {
    async refreshData() {
      this.refreshing = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500)) // Kısa animasyon için
        this.$router.go(0)
      } finally {
        this.refreshing = false
      }
    },
    loadThemePreference() {
      const savedTheme = localStorage.getItem('theme-preference')
      const themeExpiry = localStorage.getItem('theme-preference-expiry')
      
      if (savedTheme && themeExpiry) {
        const now = new Date().getTime()
        if (now < parseInt(themeExpiry)) {
          this.$vuetify.theme.global.name = savedTheme
        } else {
          // Süresi dolmuş, temizle
          localStorage.removeItem('theme-preference')
          localStorage.removeItem('theme-preference-expiry')
        }
      }
    },
    saveThemePreference(theme) {
      const expiryDate = new Date()
      expiryDate.setDate(expiryDate.getDate() + 180) // 180 gün
      
      localStorage.setItem('theme-preference', theme)
      localStorage.setItem('theme-preference-expiry', expiryDate.getTime().toString())
    },
    toggleTheme() {
      const newTheme = this.$vuetify.theme.global.name === 'light' ? 'dark' : 'light'
      this.$vuetify.theme.global.name = newTheme
      this.saveThemePreference(newTheme)
    },
    logout() {
      clearAuthCookie()
      this.$router.push('/login')
    }
  }
}
</script>
<style sc
oped>
/* App Bar Styles */
.app-bar {
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.v-theme--dark .app-bar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background-color: #1e1e1e !important;
}

.app-title {
  font-weight: 600;
  font-size: 1.25rem;
  letter-spacing: 0.5px;
}

/* Desktop Navigation */
.nav-btn {
  height: 40px;
  border-radius: 20px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.nav-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

.nav-btn--active {
  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.nav-btn--active::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 3px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 2px;
}

/* Dark theme navigation */
.v-theme--dark .nav-btn:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.v-theme--dark .nav-btn--active {
  background-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.v-theme--dark .nav-btn--active::before {
  background-color: rgba(168, 213, 186, 0.9);
}

/* Action Buttons */
.action-btn {
  transition: all 0.3s ease;
  border-radius: 50%;
}

.action-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: scale(1.05);
}

.v-theme--dark .action-btn:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

/* Mobile Drawer */
.mobile-drawer {
  background: linear-gradient(135deg, #F8FFFE 0%, #E8F5E8 100%);
}

.drawer-header {
  background: linear-gradient(135deg, #2C5F7C 0%, #A8D5BA 100%);
  color: white;
  padding: 20px 16px;
  margin-bottom: 0;
}

.drawer-item {
  margin: 4px 8px;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.drawer-item:hover {
  background-color: rgba(168, 213, 186, 0.15);
  transform: translateX(4px);
}

.drawer-item.v-list-item--active {
  background-color: rgba(44, 95, 124, 0.15);
  color: #2C5F7C;
}

/* Main Content */
.main-content {
  background-color: #F8FFFE;
  min-height: 100vh;
}

/* Responsive Design */
@media (max-width: 960px) {
  .app-title {
    font-size: 1.1rem;
  }
}

@media (max-width: 600px) {
  .app-title {
    font-size: 1rem;
  }

  .app-bar {
    height: 56px !important;
  }
}

/* Dark Theme Support */
.v-theme--dark .main-content {
  background-color: #121212;
}

.v-theme--dark .mobile-drawer {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}

.v-theme--dark .drawer-item:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.v-theme--dark .drawer-item.v-list-item--active {
  background-color: rgba(168, 213, 186, 0.15);
  color: #A8D5BA;
}

/* Dark theme app title */
.v-theme--dark .app-title {
  color: rgba(255, 255, 255, 0.95);
}

/* Dark theme menu items */
.v-theme--dark .v-list-item-title {
  color: rgba(255, 255, 255, 0.87);
}

.v-theme--dark .v-list-item-icon .v-icon {
  color: rgba(255, 255, 255, 0.7);
}

/* Animation for drawer */
.mobile-drawer .v-list-item {
  animation: slideInLeft 0.3s ease forwards;
}

.mobile-drawer .v-list-item:nth-child(1) { animation-delay: 0.1s; }
.mobile-drawer .v-list-item:nth-child(2) { animation-delay: 0.2s; }
.mobile-drawer .v-list-item:nth-child(3) { animation-delay: 0.3s; }
.mobile-drawer .v-list-item:nth-child(4) { animation-delay: 0.4s; }

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Loading animation for refresh button */
.action-btn .v-icon {
  transition: transform 0.3s ease;
}

.action-btn:hover .v-icon {
  transform: rotate(180deg);
}
</style>

/* Login Container */
.login-container {
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}